//#region package.json
var version = "1.6.9";
//#endregion
export { version };
